const baseUrl = 'https://dev.crm.empresascec.com';

export const environment = {
  production: false,
  baseUrl: baseUrl,
  coreApiBaseUrl: baseUrl + '/core',
  documetApiBaseUrl: baseUrl + '/documents',
  identityApiBaseUrl: baseUrl + '/identity',
  communicationApiBaseUrl: baseUrl + '/communication',
  financeApiBaseUrl: baseUrl + '/finance',
  externalApiBaseUrl: baseUrl + '/external',
  clientId: 'mojitocrm_web',
  scope: 'mojitocrm_api',
  mojitoTrackingUrl: 'https://app.pre.mojito360.com/tracking/detail/',
  odooBaseUrl: 'https://empresascectestt36.odoo.com/odoo',
};
